// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"3093":"b5bc02cdef5dac3fc382","3180":"bff83a125eaab69b851a","9635":"806ab674a8d3595818d8"}[chunkId] + ".css";
};